<template>
  <div class="pa-4">
    <breadcrumb />

    <h2 class="black--text mb-4">{{ $t("reports.aiCredit.title") }}</h2>

    <v-card outlined class="mb-4">
      <v-tabs v-model="tab" show-arrows>
        <v-tab>{{ $t("reports.aiCredit.tabCooperativeCredits") }}</v-tab>
        <v-tab>{{ $t("reports.aiCredit.tabCreditRates") }}</v-tab>
        <v-tab>{{ $t("reports.aiCredit.tabUsageLog") }}</v-tab>
        <v-tab>{{ $t("reports.aiCredit.tabFeedback") }}</v-tab>
      </v-tabs>
    </v-card>

    <cooperative-credits v-if="tab === 0" />
    <credit-rates v-else-if="tab === 1" />
    <usage-log v-else-if="tab === 2" />
    <feedback-dashboard v-else-if="tab === 3" />
  </div>
</template>

<script>
import CooperativeCredits from "./components/CooperativeCredits.vue";
import CreditRates from "./components/CreditRates.vue";
import UsageLog from "./components/UsageLog.vue";
import FeedbackDashboard from "./components/FeedbackDashboard.vue";

export default {
  name: "SuperAdminAiReportsManagement",
  components: { CooperativeCredits, CreditRates, UsageLog, FeedbackDashboard },
  data() {
    return { tab: 0 };
  },
};
</script>
